import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackVisit } from "../lib/api";

const vid = () => {
  let v = localStorage.getItem("ucmp_vid");
  if (!v) { v = "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("ucmp_vid", v); }
  return v;
};
const sid = () => {
  let s = sessionStorage.getItem("ucmp_sid");
  if (!s) { s = "s-" + Math.random().toString(36).slice(2); sessionStorage.setItem("ucmp_sid", s); }
  return s;
};

export const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/region-blocked")) return;
    trackVisit({
      path: location.pathname,
      referrer: document.referrer || "",
      visitor_id: vid(),
      session_id: sid(),
      screen: `${window.innerWidth}x${window.innerHeight}`,
    });
  }, [location.pathname]);
  return null;
};
